import { useEffect, useState } from 'react';
import {
  Box,
  FormLabel,
  LinearProgress,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

import useInterval from './useInterval';

const transportSlogans = [
  'Loading... Like a slow-moving freight train.',
  'Waiting is the hardest part... Loading!',
  'This loading screen is on a road trip.',
  "Cargo's loading, humor's unloading!",
  "Loading... So you don't have to carry the weight!",
  "Hold tight, we're trucking through this loading screen!",
  'Our loading screen is the tortoise, not the hare!',
  "Don't worry, we're just packing some laughs!",
  'Loading... The speed limit is humor!',
  'Traffic jam on the loading highway. Patience, please!',
];
const firstSlogan = Math.floor(Math.random() * transportSlogans.length);

export default function LoadingScreen() {
  const theme = useTheme();

  const [activeSlogan, setActiveSlogan] = useState(firstSlogan);
  const [newSlogan, setNewSlogan] = useState(firstSlogan);
  const [opacity, setOpacity] = useState(1);

  useInterval(() => {
    setNewSlogan(Math.floor(Math.random() * transportSlogans.length));
  }, 2000);

  useEffect(() => {
    setOpacity(0);
    const timeout = setTimeout(() => {
      setActiveSlogan(newSlogan);
      setOpacity(1);
    }, 750);
    return () => clearTimeout(timeout);
  }, [newSlogan]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 3,
      }}
    >
      <Stack
        spacing={4}
        sx={{
          alignItems: "center",
          width: '100%',
          maxWidth: 420
        }}>
        {/* Logo */}

        <Box
          component="img"
          src="/static/logo.svg"
          alt="Rotra"
          sx={{
            width: 120,
            userSelect: 'none',
          }}
        />

        {/* Title */}

        <Box sx={{ position: 'relative' }}>
          <FormLabel
            sx={{
              transition: 'opacity 0.75s linear',
              opacity,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                textAlign: "center",
                lineHeight: 1.25,
                fontSize: '1.05rem'
              }}>
              {transportSlogans[activeSlogan]}
            </Typography>
          </FormLabel>
          <FormLabel
            sx={{
              transition: 'opacity 0.75s linear',
              opacity: 1 - opacity,
              position: 'absolute',
              left: 0,
              top: 0,
              right: 0,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                textAlign: "center",
                lineHeight: 1.25,
                fontSize: '1.05rem'
              }}>
              {transportSlogans[activeSlogan]}
            </Typography>
          </FormLabel>
        </Box>

        {/* Progress */}

        <Box sx={{ width: '100%' }}>
          <LinearProgress
            sx={{
              height: 6,
              borderRadius: 999,
              bgcolor: theme.palette.action.hover,

              '& .MuiLinearProgress-bar': {
                borderRadius: 999,
              },
            }}
          />

          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              mt: 1.5
            }}>
            Loading your experience...
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
